module.exports = __webpack_public_path__ + "img/sebrae_turismo_logo_nome.e3e16b9e.png";